import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import AuthControl from 'components/AuthControl';
import { partnerRole } from 'constants/roles';
import { DropdownMenu, DropdownToggle, Tooltip, UncontrolledDropdown } from 'reactstrap';
import { ImpersonationIcon } from 'app/employer/vectors';
import PartnerImpersonationForm from './PartnerImpersonationForm';
import SwitchBackPartnerImpersonationForm from './SwitchBackPartnerImpersonationForm';

const rolesVisibleTo = {
   partner: [partnerRole.admin],
};

const PartnerImpersonationDropdown = (props) => {
   const isImpersonatingPartnerUser = useSelector((state) => !!(state?.authReducer?.loggedInUserPartner?.impersonating));
   const [isOpenTooltip, setIsOpenTooltip] = useState(false);

   const toggleIsOpenTooltip = useCallback(() => {
      setIsOpenTooltip((prevState) => !prevState);
   }, []);

   return (
      <>
         {
            isImpersonatingPartnerUser
               ? (
                  <UncontrolledDropdown nav inNavbar className='mr-2'>
                     <DropdownToggle nav className='nav-icon dropdown-toggle'>
                        <div className='position-relative'>
                           <ImpersonationIcon id='impersonationSwitch' width='20' fill='#A0C8A9'/>
                           <Tooltip
                              placement='bottom'
                              isOpen={ isOpenTooltip }
                              toggle={toggleIsOpenTooltip }
                              target='impersonationSwitch'
                              trigger='hover'
                           >
                              Switch back to Admin
                           </Tooltip>
                        </div>
                     </DropdownToggle>
                     <DropdownMenu right className='dropdown-menu-lg py-0'>
                        <div className='dropdown-menu-header position-relative'>
                           Impersonating as User
                        </div>
                        <div className='m-3'>
                           <SwitchBackPartnerImpersonationForm/>
                        </div>
                     </DropdownMenu>
                  </UncontrolledDropdown>
               )
               : (
                  <AuthControl
                     rolesVisibleTo={rolesVisibleTo}
                  >
                     <UncontrolledDropdown nav inNavbar className='mr-2'>
                        <DropdownToggle nav className='nav-icon dropdown-toggle'>
                           <div className='position-relative'>
                              <ImpersonationIcon id='impersonationSwitch' width='20' fill='#A0C8A9'/>
                              <Tooltip
                                 placement='bottom'
                                 isOpen={ isOpenTooltip }
                                 toggle={toggleIsOpenTooltip }
                                 target='impersonationSwitch'
                                 trigger='hover'
                              >
                                 Impersonate as Partner User
                              </Tooltip>
                           </div>
                        </DropdownToggle>
                        <DropdownMenu right className='dropdown-menu-lg py-0'>
                           <div className='dropdown-menu-header position-relative'>
                              Impersonate a&nbsp;
                              <strong>
                                 <u>
                                    Partner
                                 </u>
                              </strong>
                              &nbsp;User
                           </div>
                           <div className='m-3'>
                              <PartnerImpersonationForm/>
                           </div>
                        </DropdownMenu>
                     </UncontrolledDropdown>
                  </AuthControl>
               )
         }
      </>
   );
};

export default PartnerImpersonationDropdown;
